/**
 * Copying to the clipboard.
 *
 * The browser only hands out the clipboard on https and on localhost, which covers
 * the live site and the teacher's own machine. Anywhere else the caller is told it
 * failed so the screen can ask the teacher to copy by hand, rather than pretending.
 */

/** Puts text on the clipboard. Returns false if the browser refused. */
export async function copyText(text: string): Promise<boolean> {
  if (!window.isSecureContext) return false;
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    return false;
  }
}
